"use strict";
var TimerObservable_1 = require('./TimerObservable');
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/rxjs/observable/timer.js
// module id = 222
// module chunks = 1